// 统一管理消息锚点，避免 clientMessageId / timestamp 规则散落在多个 UI 文件。

export type MessageAnchor = {
  clientMessageId: string;
  timestamp: string;
};

export type AnchorMessageLike = {
  clientMessageId?: unknown;
  timestamp?: unknown;
};

function normalizeAnchorValue(value: unknown): string {
  return typeof value === 'string' ? value.trim() : '';
}

export function buildMessageAnchor(message: AnchorMessageLike | null | undefined): MessageAnchor {
  return {
    clientMessageId: normalizeAnchorValue(message?.clientMessageId),
    timestamp: normalizeAnchorValue(message?.timestamp),
  };
}

export function hasMessageAnchor(anchor: MessageAnchor | null | undefined): boolean {
  return !!(anchor && (anchor.clientMessageId || anchor.timestamp));
}
